import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Popover, Stack, Tooltip, Typography } from '@mui/material';
import { shuffle } from 'lodash'; // Importing the shuffle function from a library like Lodash
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ScoreGrade, hasAnySpokenSentenceScore, sentenceScoreAllGood, sentenceScoreNonSilentFailed, sentenceScoreAnyFailed } from '../../Score';
import { DialogPromptImageSelectSpeak } from '../../api/DialogPromptApi';
import { ISentenceScore, ScoreApi } from '../../api/ScoreApi';
import { IVocabularyWord } from '../../api/VocabularyWordApi';
import AppBarContext from '../../context/AppBarContext';
import ChatBubble from '../ChatBubble';
import { handleErrorMessage } from '../ErrorDialog';
import { SentenceScoreMediumResult, SentenceScoreTryAgain, SentenceScoreTryAgainNo, SentenceScoreTryAgainYes, getAudioByText } from './DialogPromptComponent';

import { useLocation } from 'react-router-dom';
import { AudioApi } from '../../api/AudioApi';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // outline rounded doesn't exist?
import { useAudioRecorder } from '../../AudioRecorder';
import { UserDialogPromptApi } from '../../api/UserDialogPromptApi';
import AddSelfStudyBlueIcon from '../../asset/icon-add-self-study-blue.png';
import MicrophoneBlueIcon from '../../asset/icon-microphone-blue.png';
import RightArrowBlueIcon from '../../asset/icon-right-arrow-blue.png';
import AudioWaveIcon from '../../asset/icons8-audio-wave.gif';
import { useAudioPlayer } from '../../context/AudioPlayerContext';
import DialogPromptFooterContext from '../../context/DialogPromptFooterContext';
import { scrollElementIntoViewWithFallback } from '../../util/scrollUtils';
import AddSentenceDialog from '../AddSentenceDialog';
import { TeacherAudioActions, getSelectedTeacherSpeakerRole } from '../TeacherAudioReportButton';
import WordPinyin from '../WordPinyin';

interface DialogPromptImageSelectSpeakComponentProps {
    dialogPrompt: DialogPromptImageSelectSpeak;
    setDialogPromptComplete: (dialogPromptId: number) => void;
    showAvatar?: boolean;
    chatBubbleContainerRef: React.RefObject<HTMLDivElement>;
    isSettings?: boolean;
}

const DialogPromptImageSelectSpeakComponent: React.FC<DialogPromptImageSelectSpeakComponentProps> = ({ dialogPrompt, setDialogPromptComplete, showAvatar = true, chatBubbleContainerRef }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const { playAudio } = useAudioPlayer();

    const { setLeftNavigationList, setRightNavigationList, setActionList, clearFooterList } = React.useContext(DialogPromptFooterContext)

    const [chatBubbleDone, setChatBubbleDone] = React.useState(false);
    const [chatBubbleTeacherChinesePromptDone, setChatBubbleTeacherChinesePromptDone] = React.useState(false);
    const [selectedVocabularyWord, setSelectedVocabularyWord] = React.useState<IVocabularyWord | undefined>(undefined)
    const [vocabularyWordImageDone, setVocabularyWordImageDone] = React.useState(false)
    // const [chatBubbleStudentResponsePromptDone, setChatBubbleStudentResponsePromptDone] = React.useState(false);
    const [chatBubbleTeacherEnglishPromptDone, setChatBubbleTeacherEnglishPromptDone] = React.useState(false);

    const imageRef = React.useRef<HTMLImageElement>(null);
    const selectedVocabularyWordRef = React.useRef<HTMLDivElement>(null);

    const [imageSize, setImageSize] = React.useState<{ width: number; height: number } | null>(null);
    const [showLightbox, setShowLightbox] = React.useState(false);
    const [hovering, setHovering] = React.useState(false);
    const [previewIndex, setPreviewIndex] = React.useState<number | null>(null);
    const [shuffledVocabularyWordList, setShuffledVocabularyWordList] = React.useState<IVocabularyWord[]>([]);

    const previewVocabularyWord =
        previewIndex !== null ? shuffledVocabularyWordList[previewIndex] : null;

    const handlePrev = () => {
        setPreviewIndex(prev => {
            if (prev === null) return prev;
            return prev === 0
                ? shuffledVocabularyWordList.length - 1
                : prev - 1;
        });
    };

    const handleNext = () => {
        setPreviewIndex(prev => {
            if (prev === null) return prev;
            return prev === shuffledVocabularyWordList.length - 1
                ? 0
                : prev + 1;
        });
    };

    const [answerList, setAnswerList] = React.useState<React.JSX.Element[]>([])


    const [promptAudio, setPromptAudio] = React.useState<Blob | null | undefined>(undefined);
    const [teacherChinesePromptAudio, setTeacherChinesePromptAudio] = React.useState<Blob | null | undefined>(undefined);
    const [yesResponseAudio, setYesResponseAudio] = React.useState<Blob | null | undefined>(undefined);
    const [noResponseAudio, setNoResponseAudio] = React.useState<Blob | null | undefined>(undefined);

    const [sentenceScoreMediumResultAudio, setSentenceScoreMediumResultAudio] = React.useState<Blob | null | undefined>(undefined);
    const [sentenceScoreTryAgainAudio, setSentenceScoreTryAgainAudio] = React.useState<Blob | null | undefined>(undefined);
    const [, setSentenceScoreTryAgainYesAudio] = React.useState<Blob | null | undefined>(undefined);
    const [, setSentenceScoreTryAgainNoAudio] = React.useState<Blob | null | undefined>(undefined);

    const [isScoring, setIsScoring] = React.useState(false);

    const [sentenceScoreList, setSentenceScoreList] = React.useState<ISentenceScore[]>([]);
    const [chatBubbleSentenceScoreDone, setChatBubbleSentenceScoreDone] = React.useState<boolean[]>([]);
    const [chatBubbleTeacherResponseDone, setChatBubbleTeacherResponseDone] = React.useState<boolean[]>([]);
    const [tryAgainClickedList, setTryAgainClickedList] = React.useState<(boolean | null)[]>([]);

    const [chatBubbleTryAgainDone, setChatBubbleTryAgainDone] = React.useState(false);
    const [chatBubbleContinueDone, setChatBubbleContinueDone] = React.useState(false);

    const touchStartX = React.useRef<number | null>(null);
    const touchEndX = React.useRef<number | null>(null);

    const minSwipeDistance = 50;

    const onTouchStart = (e: React.TouchEvent) => {
        touchStartX.current = e.targetTouches[0].clientX;
    };

    const onTouchMove = (e: React.TouchEvent) => {
        touchEndX.current = e.targetTouches[0].clientX;
    };

    const onTouchEnd = () => {
        if (touchStartX.current === null || touchEndX.current === null) return;

        const distance = touchStartX.current - touchEndX.current;

        if (distance > minSwipeDistance) {
            handleNext();
        }

        if (distance < -minSwipeDistance) {
            handlePrev();
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    const [openCancelDialog, setOpenCancelDialog] = React.useState(false);
    const [addSentenceDialogOpen, setAddSentenceDialogOpen] = React.useState(false);

    const selectedAnswerAudioReportContext = React.useMemo(() => {
        if (!selectedVocabularyWord) return null;
        return {
            sentenceId: selectedVocabularyWord.audio_sentence_id,
            dialogPromptId: dialogPrompt.id,
            textToSpeechSpeakerId: getSelectedTeacherSpeakerRole(),
            audioText: selectedVocabularyWord.audio_sentence || selectedVocabularyWord.word,
            audioRole: 'image_select_speak_selected_answer',
        };
    }, [dialogPrompt.id, selectedVocabularyWord]);


    React.useEffect(() => {
        clearFooterList()
        getAudioByText(history, setErrorMessage, dialogPrompt.prompt, setPromptAudio)
        getAudioByText(history, setErrorMessage, dialogPrompt.teacher_chinese_prompt, setTeacherChinesePromptAudio)
        getAudioByText(history, setErrorMessage, dialogPrompt.yes_response, setYesResponseAudio)
        getAudioByText(history, setErrorMessage, dialogPrompt.no_response, setNoResponseAudio)


        getAudioByText(history, setErrorMessage, SentenceScoreMediumResult, setSentenceScoreMediumResultAudio)
        getAudioByText(history, setErrorMessage, SentenceScoreTryAgain, setSentenceScoreTryAgainAudio)
        getAudioByText(history, setErrorMessage, SentenceScoreTryAgainYes, setSentenceScoreTryAgainYesAudio)
        getAudioByText(history, setErrorMessage, SentenceScoreTryAgainNo, setSentenceScoreTryAgainNoAudio)

    }, [clearFooterList, dialogPrompt.no_response, dialogPrompt.prompt, dialogPrompt.teacher_chinese_prompt, dialogPrompt.yes_response, history, setErrorMessage]);

    React.useEffect(() => {
        if (chatBubbleDone) {
            if (dialogPrompt.teacher_chinese_prompt && dialogPrompt.teacher_chinese_prompt.trim().length > 0) {
                // do nothing, chatBubble below will set flag
            } else {
                setChatBubbleTeacherChinesePromptDone(true)
            }
        }
    }, [chatBubbleDone, dialogPrompt.teacher_chinese_prompt])

    const handleAnswerClick = React.useCallback((vocabularyWordId: number) => {
        const vocabularyWord = dialogPrompt.vocabulary_word_list.find(word => word.id === vocabularyWordId);
        setSelectedVocabularyWord(vocabularyWord);
        // Reset image state when a new word is selected
        setImageSize(null);
        setHovering(false);
        setShowLightbox(false);
        UserDialogPromptApi.addCorrectAnswer(dialogPrompt.id)
            .catch(err => { handleErrorMessage(err, setErrorMessage, history, location); })
    }, [dialogPrompt.vocabulary_word_list, dialogPrompt.id, setErrorMessage, history, location]);

    React.useEffect(() => {
        if (chatBubbleTeacherChinesePromptDone) {
            const shuffled = shuffle([...dialogPrompt.vocabulary_word_list]);
            setShuffledVocabularyWordList(shuffled);
            const wordAnswerList = shuffled.map((vocabularyWordOption, index) => (
                <Box
                    key={vocabularyWordOption.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        p: 0.5,
                        m: 1,
                        gap: 1,
                        position: 'relative',
                        zIndex: 1,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            zIndex: 10,
                        }
                    }}
                >
                    {vocabularyWordOption.image_url ? (
                        <img
                            src={vocabularyWordOption.image_url}
                            alt={vocabularyWordOption.word}
                            onClick={() => setPreviewIndex(index)}
                            style={{
                                maxHeight: 160,
                                maxWidth: '100%',
                                height: 'auto',
                                width: 'auto',
                                objectFit: 'contain',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                transition: 'transform 0.2s ease, filter 0.2s ease',
                                filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.08))',
                            }}
                            onMouseOver={(e) => {
                                (e.currentTarget as HTMLImageElement).style.transform = 'scale(1.08)';
                                (e.currentTarget as HTMLImageElement).style.filter = 'drop-shadow(0 4px 16px rgba(0,0,0,0.12))';
                            }}
                            onMouseOut={(e) => {
                                (e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';
                                (e.currentTarget as HTMLImageElement).style.filter = 'drop-shadow(0 2px 8px rgba(0,0,0,0.08))';
                            }}
                        />
                    ) : null}
                    <Button
                        variant="outlined"
                        size="small"
                        aria-label={`Select answer ${vocabularyWordOption.word}`}
                        onClick={() => handleAnswerClick(vocabularyWordOption.id)}
                        sx={{
                            minWidth: 80,
                            fontSize: '0.8rem',
                            textTransform: 'none',
                            borderRadius: '8px',
                            padding: '6px 16px',
                            lineHeight: 1.2,
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: '#0062FF',
                                color: '#fff',
                                borderColor: '#0062FF',
                            }
                        }}
                    >
                        Select
                    </Button>

                </Box>
            ));

            setActionList(wordAnswerList)
            setAnswerList(wordAnswerList)
        }
    }, [chatBubbleTeacherChinesePromptDone, dialogPrompt.vocabulary_word_list, handleAnswerClick, setActionList])

    React.useEffect(() => {
        // scroll after image answers have been rendered
        if (answerList && answerList.length > 0) {
            // use requestAnimationFrame or MutationObserver here
            requestAnimationFrame(() => {
                if (chatBubbleContainerRef.current) {
                    scrollElementIntoViewWithFallback(chatBubbleContainerRef.current);
                }
            });
        }
    }, [answerList, chatBubbleContainerRef])

    const handleImageLoad = () => {
        if (imageRef.current) {
            setImageSize({
                width: imageRef.current.naturalWidth,
                height: imageRef.current.naturalHeight,
            });
        }
    };

    React.useEffect(() => {
        if (selectedVocabularyWord) {
            // make sure to scroll after the image is loaded.
            const handleImageLoadAndScroll = () => {
                handleImageLoad();
                if (chatBubbleContainerRef.current) {
                    scrollElementIntoViewWithFallback(chatBubbleContainerRef.current);
                }
                setVocabularyWordImageDone(true)
            };

            const imageEl = imageRef.current;
            if (imageEl) {
                if (imageEl.complete && imageEl.naturalHeight !== 0) {
                    // If image is already loaded
                    handleImageLoadAndScroll();
                } else {
                    // Image is not yet loaded, attach event listener
                    imageEl.addEventListener('load', handleImageLoadAndScroll);
                }
            }

            return () => {
                if (imageEl) {
                    imageEl.removeEventListener('load', handleImageLoadAndScroll);
                }
            };
        }
    }, [selectedVocabularyWord, chatBubbleContainerRef])

    React.useEffect(() => {
        if (selectedVocabularyWord && vocabularyWordImageDone) {
            if (selectedVocabularyWord.student_response_prompt && selectedVocabularyWord.student_response_prompt.trim().length > 0 && selectedVocabularyWord.student_response_prompt != "<Answer/>") {
                // do nothing, chatBubble below will set flag
            } else {
                setChatBubbleTeacherChinesePromptDone(true)
                // setChatBubbleStudentResponsePromptDone(true)
            }
        }

    }, [vocabularyWordImageDone, selectedVocabularyWord])

    const handleAnswerSentenceSpeakerClick = () => {
        if (selectedVocabularyWord) {
            const audioPromise = AudioApi.getTeacherSentence(selectedVocabularyWord.audio_sentence_id)

            audioPromise
                .then(response => {
                    // check if the response was successful
                    if (response.status >= 300) {
                        throw new Error('Getting male audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(blob => {
                    playAudio(blob)
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    };

    const [infoAnchorEl, setInfoAnchorEl] = React.useState<null | HTMLElement>(null);
    const infoOpen = Boolean(infoAnchorEl);

    const handleInfoClick = (event: React.MouseEvent<HTMLElement>) => {
        setInfoAnchorEl(event.currentTarget);
    };

    const handleInfoClose = () => {
        setInfoAnchorEl(null);
    };

    React.useEffect(() => {
        if (chatBubbleTeacherEnglishPromptDone && selectedVocabularyWordRef.current) {
            scrollElementIntoViewWithFallback(selectedVocabularyWordRef.current);
        }
    }, [chatBubbleTeacherEnglishPromptDone]);

    /**
     * speaking stuff
     */


    const onStop = React.useCallback((audioData: Blob) => {
        setIsScoring(true)
        const formData = new FormData();
        formData.append('audio', audioData);

        if (selectedVocabularyWord && selectedVocabularyWord.audio_sentence_id >= 0) {
            ScoreApi.getScore(selectedVocabularyWord.audio_sentence_id, formData)
                .then(response => {
                    setIsScoring(false)
                    if (response.status >= 300) {
                        throw new Error('Scoring audio was not ok statuscode=' + response.status + " " + response.statusText);
                    }
                    return response.data;
                })
                .then(responseJson => {
                    UserDialogPromptApi.addSpeakingAttempt(dialogPrompt.id, responseJson.score_mean)
                        .catch(err => { handleErrorMessage(err, setErrorMessage, history, location); })
                    responseJson.audioData = audioData;
                    setSentenceScoreList((previous) => [...previous, responseJson]);
                })
                .catch(err => {
                    handleErrorMessage(err, setErrorMessage, history, location);
                })
        }
    }, [selectedVocabularyWord, dialogPrompt.id, setErrorMessage, history, location]);
    const { startRecording, stopRecording, isRecording } = useAudioRecorder({ setErrorMessage, onStop });


    const [shouldJiggleSkipArrow, setShouldJiggleSkipArrow] = React.useState(false);
    const jiggleKeyframes = React.useMemo(() => ({
        '@keyframes jiggle': {
            '0%': { transform: 'rotate(0deg)' },
            '12.5%': { transform: 'rotate(-20deg)' },
            '37.5%': { transform: 'rotate(20deg)' },
            '52.5%': { transform: 'rotate(-20deg)' },
            '77.5%': { transform: 'rotate(20deg)' },
            '100%': { transform: 'rotate(0)' },
        },
    }), []);
    const jiggleDuration = 500
    const jiggleIteration = 8

    const handleCancelClick = React.useCallback(() => {
        setOpenCancelDialog(true);
    }, []);

    const updateTryAgainClickedList = React.useCallback((tryAgain: boolean) => {
        const index = sentenceScoreList.length - 1;
        setTryAgainClickedList(previous => {
            const updatedArray = [...previous];
            updatedArray[index] = tryAgain;
            return updatedArray;
        })
    }, [sentenceScoreList.length]);

    const handleNextWordClick = React.useCallback(() => {
        setChatBubbleTryAgainDone(false)
        updateTryAgainClickedList(false)
    }, [updateTryAgainClickedList]);

    const handleTryAgainClick = React.useCallback(() => {
        setChatBubbleTryAgainDone(false)
        updateTryAgainClickedList(true)
    }, [updateTryAgainClickedList]);

    const handleAddSentenceClick = React.useCallback(() => {
        setAddSentenceDialogOpen(true);
    }, []);

    React.useEffect(() => {
        if (sentenceScoreList.length === 0) return;

        const last = sentenceScoreList[sentenceScoreList.length - 1];
        if (!sentenceScoreNonSilentFailed(last)) {
            setShouldJiggleSkipArrow(false);
            return;
        }

        const failedCount = sentenceScoreList.reduce(
            (acc, sentenceScore) => acc + (sentenceScoreNonSilentFailed(sentenceScore) ? 1 : 0),
            0
        );

        if (failedCount % 2 === 0) {
            setShouldJiggleSkipArrow(true);
            const totalDuration = jiggleDuration * jiggleIteration
            const t = setTimeout(() => setShouldJiggleSkipArrow(false), totalDuration + 50); // length of the animation
            return () => clearTimeout(t);
        } else {
            setShouldJiggleSkipArrow(false);
        }
    }, [sentenceScoreList]);

    React.useEffect(() => {
        if (selectedVocabularyWord && chatBubbleTryAgainDone == false) {
            if (sentenceScoreList.length == 0 || sentenceScoreList[sentenceScoreList.length - 1].passing_grade == ScoreGrade.Bad || tryAgainClickedList[sentenceScoreList.length - 1]) {
                if (hasAnySpokenSentenceScore(sentenceScoreList)) {
                    setLeftNavigationList([
                        <IconButton
                            aria-label="Skip exercise"
                            onClick={handleCancelClick}
                            sx={{
                                ...jiggleKeyframes,
                                animation: shouldJiggleSkipArrow ? `jiggle ${jiggleDuration}ms ease-in-out ${jiggleIteration}` : 'none',
                            }}
                        >
                            <img src={RightArrowBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '24px' }} />
                        </IconButton>
                    ])
                }
                if (selectedVocabularyWord && selectedVocabularyWord.audio_sentence_id >= 0) {
                    setRightNavigationList([
                        <Tooltip title="Add to Pronunciation" arrow>
                            <IconButton aria-label="Add to Pronunciation" onClick={handleAddSentenceClick} sx={{ alignSelf: 'center' }}>
                                <img src={AddSelfStudyBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '24px' }} />
                            </IconButton>
                        </Tooltip>
                    ])
                }
                setActionList([
                    <IconButton aria-label={isRecording ? "Stop recording" : "Record"} onClick={isRecording ? stopRecording : startRecording}>
                        {isRecording ? <img src={AudioWaveIcon} alt="Recording" style={{ height: '100%', width: 'auto', maxHeight: '36px' }} />
                            : isScoring ? <CircularProgress size={24} sx={{ height: '100%', width: 'auto', maxHeight: '36px' }} />
                                : <img src={MicrophoneBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '36px' }} />}
                    </IconButton>
                ])
            }
        }
    }, [selectedVocabularyWord, sentenceScoreList, isRecording, isScoring, chatBubbleTryAgainDone, tryAgainClickedList, shouldJiggleSkipArrow, jiggleKeyframes, setActionList, setLeftNavigationList, setRightNavigationList, startRecording, stopRecording, handleCancelClick, handleAddSentenceClick]);


    React.useEffect(() => {
        if (chatBubbleTryAgainDone) {
            setLeftNavigationList([
                <IconButton aria-label="Skip exercise" onClick={handleCancelClick}>
                    <img src={RightArrowBlueIcon} alt="" style={{ height: '100%', width: 'auto', maxHeight: '24px' }} />
                </IconButton>
            ])
            setActionList([
                <Button variant="contained" onClick={handleNextWordClick} className="secondaryButton" >
                    No, Continue On
                </Button>,
                <Button variant="contained" onClick={handleTryAgainClick} >
                    Yes, Try Again
                </Button>
            ])
        }
    }, [chatBubbleTryAgainDone, handleNextWordClick, handleTryAgainClick, setActionList, setLeftNavigationList, handleCancelClick]);

    /**
     * cancel dialog
     */

    const handleCancelDialogConfirm = () => {
        setOpenCancelDialog(false);
        setChatBubbleContinueDone(true);
    };

    const handleCancelDialogCancel = () => {
        setOpenCancelDialog(false);
    };

    React.useEffect(() => {
        if (chatBubbleContinueDone) {
            clearFooterList()
            setDialogPromptComplete(dialogPrompt.id)

        }
    }, [chatBubbleContinueDone, clearFooterList, dialogPrompt.id, setDialogPromptComplete])


    /**
     * add custom sentence
     */

    return (
        <Stack spacing={2} sx={{ mx: 2 }}>
            <ChatBubble
                isTeacher={dialogPrompt.is_teacher}
                message={dialogPrompt.prompt}
                messageAudio={promptAudio ? promptAudio : null}
                showAvatar={showAvatar}
                setChatBubbleDone={setChatBubbleDone}
                chatBubbleContainerRef={chatBubbleContainerRef}
                dialogPromptId={dialogPrompt.id}
                audioRole="prompt"
            />
            {chatBubbleDone &&
                <ChatBubble
                    isTeacher={true}
                    message={dialogPrompt.teacher_chinese_prompt}
                    messageAudio={teacherChinesePromptAudio ? teacherChinesePromptAudio : null}
                    showAvatar={showAvatar}
                    setChatBubbleDone={setChatBubbleTeacherChinesePromptDone}
                    chatBubbleContainerRef={chatBubbleContainerRef}
                    dialogPromptId={dialogPrompt.id}
                    audioRole="teacher_chinese_prompt"
                />
            }
            {selectedVocabularyWord != null && (
                <div style={{ position: 'relative', display: 'inline-block', margin: '0 auto' }}>
                    <img
                        ref={imageRef}
                        src={selectedVocabularyWord.image ? selectedVocabularyWord.image : (selectedVocabularyWord.image_url ? selectedVocabularyWord.image_url : "broken")}
                        alt={selectedVocabularyWord.word}
                        onClick={() => setShowLightbox(true)}
                        onMouseEnter={() => setHovering(true)}
                        onMouseLeave={() => setHovering(false)}
                        style={{
                            maxHeight: '400px',
                            maxWidth: '100%',
                            height: 'auto',
                            width: 'auto',
                            display: 'block',
                            cursor: 'pointer',
                            transition: 'opacity 0.2s ease',
                            opacity: hovering ? 0.85 : 1,
                            borderRadius: '10px',
                        }}
                    />

                    {hovering && imageSize && (
                        <div style={{
                            position: 'absolute',
                            bottom: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            color: '#fff',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            pointerEvents: 'none',
                            zIndex: 10,
                        }}>
                            {imageSize.width} × {imageSize.height}
                        </div>
                    )}
                </div>
            )}

            {/* Lightbox */}
            {showLightbox && selectedVocabularyWord && (
                <div
                    onClick={() => setShowLightbox(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 9999,
                        margin: 0,
                        padding: 0,
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            gap: '8px',
                            cursor: 'default',
                        }}
                    >
                        <img
                            src={selectedVocabularyWord.image ? selectedVocabularyWord.image : (selectedVocabularyWord.image_url ? selectedVocabularyWord.image_url : "broken")}
                            alt={selectedVocabularyWord.word}
                            onLoad={(e) => {
                                const img = e.currentTarget;
                                setImageSize({
                                    width: img.naturalWidth,
                                    height: img.naturalHeight,
                                });
                            }}
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                                borderRadius: '10px',
                                boxShadow: '0 4px 24px rgba(0, 0, 0, 0.5)',
                            }}
                        />

                        {imageSize && (
                            <div
                                style={{
                                    color: '#ccc',
                                    fontSize: '12px',
                                    paddingRight: '4px',
                                }}
                            >
                                {imageSize.width} × {imageSize.height}
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Dialog
                open={previewIndex !== null}
                onClose={() => setPreviewIndex(null)}
                fullScreen
                PaperProps={{
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.96)',
                        color: '#fff',
                    }
                }}
            >
                <DialogContent
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        height: '100vh',
                        overflow: 'hidden',
                        p: 0,
                    }}
                >
                    {/* IMAGE WRAPPER */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                        }}
                        onTouchStart={onTouchStart}
                        onTouchMove={onTouchMove}
                        onTouchEnd={onTouchEnd}
                    >

                        {/* LEFT ARROW */}
                        <IconButton
                            aria-label="Previous image"
                            onClick={handlePrev}
                            sx={{
                                position: 'absolute',
                                left: 16,
                                color: '#fff',
                                backgroundColor: 'rgba(0,0,0,0.35)',
                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.55)' },
                                width: 48,
                                height: 48,
                            }}
                        >
                            ‹
                        </IconButton>

                        {/* IMAGE */}
                        {previewVocabularyWord && (
                            <img
                                src={
                                    previewVocabularyWord.image_url ||
                                    previewVocabularyWord.image ||
                                    "broken"
                                }
                                alt={previewVocabularyWord.word}
                                style={{
                                    maxWidth: '95vw',
                                    maxHeight: '85vh',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    borderRadius: '14px',
                                    boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
                                    display: 'block',
                                }}
                            />
                        )}

                        {/* RIGHT ARROW */}
                        <IconButton
                            aria-label="Next image"
                            onClick={handleNext}
                            sx={{
                                position: 'absolute',
                                right: 16,
                                color: '#fff',
                                backgroundColor: 'rgba(0,0,0,0.35)',
                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.55)' },
                                width: 48,
                                height: 48,
                            }}
                        >
                            ›
                        </IconButton>

                        {/* INDEX (attached to image container, not screen) */}
                        {previewIndex !== null && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    left: '50%',
                                    transform: 'translateX(-50%)',

                                    px: 2,
                                    py: 0.5,
                                    borderRadius: '999px',
                                    backgroundColor: 'rgba(0,0,0,0.45)',
                                    color: '#ddd',
                                    fontSize: '13px',
                                    backdropFilter: 'blur(8px)',
                                }}
                            >
                                {previewIndex + 1} / {shuffledVocabularyWordList.length}
                            </Box>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setPreviewIndex(null)} sx={{ color: '#ccc' }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (previewVocabularyWord) {
                                handleAnswerClick(previewVocabularyWord.id);
                                setPreviewIndex(null);
                            }
                        }}
                        className="secondaryButton"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* {selectedVocabularyWord != null && vocabularyWordImageDone && selectedVocabularyWord.student_response_prompt != "<Answer/>" &&
                <ChatBubble
                    isTeacher={false}
                    message={selectedVocabularyWord.student_response_prompt}
                    // messageAudio={teacherChinesePromptAudio ? teacherChinesePromptAudio : null}
                    messageAudio={null}
                    showAvatar={showAvatar}
                    setChatBubbleDone={setChatBubbleStudentResponsePromptDone}
                    chatBubbleContainerRef={chatBubbleContainerRef}
                />
            } */}
            {selectedVocabularyWord &&
                <ChatBubble
                    isTeacher={true}
                    message={selectedVocabularyWord.teacher_english_prompt}
                    messageAudio={null}
                    showAvatar={showAvatar}
                    setChatBubbleDone={setChatBubbleTeacherEnglishPromptDone}
                    chatBubbleContainerRef={chatBubbleContainerRef}
                />
            }
            {selectedVocabularyWord != null && chatBubbleTeacherEnglishPromptDone &&
                <Box ref={selectedVocabularyWordRef} sx={{ width: '100%', display: 'flex', justifyContent: 'center', pb: 2 }}>
                    <Stack direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" className="border-dark" style={{ marginBottom: '10px' }}
                        sx={{ pt: 1, pb: 1, pl: 2, pr: 3, display: 'inline-flex' }}>
                        <TeacherAudioActions
                            context={selectedAnswerAudioReportContext}
                            onPlay={handleAnswerSentenceSpeakerClick}
                            speakerAriaLabel="Play selected answer audio"
                        />
                        <WordPinyin
                            text={selectedVocabularyWord.audio_sentence}
                            pinyinList={selectedVocabularyWord.audio_sentence_pinyin}
                        />
                        {selectedVocabularyWord.word_info_text && (<>
                            <IconButton aria-label="Show selected answer info" onClick={handleInfoClick}>
                                <InfoOutlinedIcon sx={{
                                    width: 30,          // bigger width
                                    height: 30,         // bigger height
                                    color: '#0062FF',
                                }} />
                            </IconButton>
                            <Popover
                                open={infoOpen}
                                anchorEl={infoAnchorEl}
                                onClose={handleInfoClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                            >
                                <Box sx={{ p: 2, maxWidth: '300px' }}>
                                    <Typography variant="body2">{selectedVocabularyWord.word_info_text}</Typography>
                                </Box>
                            </Popover>
                        </>)}

                    </Stack>
                </Box>
            }
            {sentenceScoreList.map((sentenceScore, index) => (
                <div key={index}>
                    <ChatBubble
                        isTeacher={false}
                        message={sentenceScore.text}
                        messageAudio={null} // audio will be found through sentenceScore
                        sentenceScore={sentenceScore}
                        showAvatar={showAvatar}
                        chatBubbleContainerRef={chatBubbleContainerRef}
                        setChatBubbleDone={(done) => setChatBubbleSentenceScoreDone(previous => {
                            if (previous[index] === done) return previous;
                            const updatedArray = [...previous];
                            updatedArray[index] = done;
                            return updatedArray;
                        })}
                    />
                    {chatBubbleSentenceScoreDone[index] && (<>
                        {sentenceScoreAllGood(sentenceScore) ? (
                            <ChatBubble
                                isTeacher={true}
                                message={dialogPrompt.yes_response}
                                messageAudio={yesResponseAudio ? yesResponseAudio : null}
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                                dialogPromptId={dialogPrompt.id}
                                audioRole="yes_response"
                                setChatBubbleDone={setChatBubbleContinueDone}
                            />
                        ) : sentenceScoreAnyFailed(sentenceScore) ? (
                            <ChatBubble isTeacher={dialogPrompt.is_teacher}
                                message={dialogPrompt.no_response}
                                messageAudio={noResponseAudio ? noResponseAudio : null}
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                                dialogPromptId={dialogPrompt.id}
                                audioRole="no_response"
                                setChatBubbleDone={() => {
                                    setChatBubbleTryAgainDone(false);
                                    // set null, to skip this index
                                    setTryAgainClickedList((previous) => [...previous, null]);
                                }}
                            />
                        ) : (
                            <ChatBubble isTeacher={dialogPrompt.is_teacher}
                                message={SentenceScoreMediumResult}
                                messageAudio={sentenceScoreMediumResultAudio ? sentenceScoreMediumResultAudio : null}
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                                dialogPromptId={dialogPrompt.id}
                                audioRole="sentence_score_medium_result"
                                setChatBubbleDone={(done) => setChatBubbleTeacherResponseDone(previous => {
                                    if (previous[index] === done) return previous;
                                    const updatedArray = [...previous];
                                    updatedArray[index] = done;
                                    return updatedArray;
                                })}
                            />
                        )}
                        {chatBubbleTeacherResponseDone[index] && (
                            <ChatBubble
                                isTeacher={true}
                                message={SentenceScoreTryAgain}
                                messageAudio={sentenceScoreTryAgainAudio ? sentenceScoreTryAgainAudio : null}
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                                dialogPromptId={dialogPrompt.id}
                                audioRole="sentence_score_try_again"
                                setChatBubbleDone={setChatBubbleTryAgainDone}
                            />
                        )}
                        {tryAgainClickedList[index] === true && (
                            <ChatBubble
                                isTeacher={false}
                                message={SentenceScoreTryAgainYes}
                                messageAudio={null} // no audio for student
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                            />
                        )}
                        {tryAgainClickedList[index] === false && (
                            <ChatBubble
                                isTeacher={false}
                                message={SentenceScoreTryAgainNo}
                                messageAudio={null} // no audio for student
                                showAvatar={showAvatar}
                                chatBubbleContainerRef={chatBubbleContainerRef}
                                setChatBubbleDone={setChatBubbleContinueDone}
                            />
                        )}
                    </>)}
                </div>
            ))}
            {/* Confirmation Dialog */}
            <Dialog open={openCancelDialog} onClose={handleCancelDialogCancel}>
                <DialogTitle><Typography variant="h4" sx={{ color: '#383838' }}>Confirm Skip</Typography></DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ color: '#8D8D8D' }}>
                        Are you sure you want to skip this exercise?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between', '& .MuiButton-root': { flex: 1 } }}>
                    <Button onClick={handleCancelDialogCancel} color="primary" sx={{ color: '#787878' }}>
                        Keep trying
                    </Button>
                    <Button onClick={handleCancelDialogConfirm} color="primary" sx={{ color: '#787878' }}>
                        Skip
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Add Sentence Confirmation Dialog */}
            <AddSentenceDialog
                open={addSentenceDialogOpen}
                sentence={
                    selectedVocabularyWord
                        ? { text: selectedVocabularyWord.audio_sentence, id: selectedVocabularyWord.audio_sentence_id }
                        : null
                }
                onClose={() => setAddSentenceDialogOpen(false)}
            />

        </Stack>
    );
};

export default DialogPromptImageSelectSpeakComponent;
